"use strict";

var classNames = require("classnames");
var LoggerInstance = require("js-logger").get("Quantity");
var React = require("react");

var ProductActions = require("../actions/ProductActions");

var ProductStore = require("../stores/ProductStore");

var Quantity = React.createClass({
	propTypes: {
		className: React.PropTypes.string,
		isDesignMode: React.PropTypes.bool,
		context: React.PropTypes.string,
		tangibleCode: React.PropTypes.string,
		theme: React.PropTypes.string,
		isCustomTheme: React.PropTypes.bool,
		dataComponentId: React.PropTypes.string,
		dataNestedId: React.PropTypes.string,
		dataRepeatedId: React.PropTypes.string
	},

	handleAmountChange: function (event) {
		// must be whole number, > 0
		if (event.currentTarget.value === "0") {
			ProductActions.setQuantity(1, this.props.tangibleCode, this.state.context);
		} else if (event.currentTarget.value.match(/^\d*$/)) {
			ProductActions.setQuantity(event.currentTarget.value, this.props.tangibleCode, this.state.context);
		}
	},

	handleAmountBlur: function (event) {
		// must be whole number, > 0
		var quantity = event.currentTarget.value;
		var isValidQuantity = quantity.match(/^[1-9]\d*$/) !== null;

		if (!isValidQuantity) {
			ProductActions.setQuantity(1, this.props.tangibleCode, this.state.context);
		} else {
			ProductActions.setQuantity(quantity, this.props.tangibleCode, this.state.context);
		}
	},

	getStateFromStore: function () {
		return {
			selectedQuantity: ProductStore.getSelectedQuantity(this.state.context, this.props.tangibleCode)
		};
	},

	_onChange: function () {
		this.setState(this.getStateFromStore());
	},

	componentDidMount: function () {
		if (this.props.isDesignMode) {
			parent.window.ComponentActions.childComponentLoaded(this);
		}
		var context = this.props.context;
		var contextId = "";
		if (context) {
			switch (context) {
				case "tangible":
					context = "category";
					contextId = $(ReactDOM.findDOMNode(this)).closest("[data-component=category]").attr("id");

					if (!contextId) {
						contextId = $(ReactDOM.findDOMNode(this)).closest("[data-component=carousel]").attr("id");
						if (contextId) {
							context = "carousel";
						}
					}
					break;
				case "result":
					context = "search";
					contextId = $(ReactDOM.findDOMNode(this)).closest("[data-component=searchResults]").attr("id");
					break;
			}
			context += `_${contextId}`;
		}
		// At this point, selectedQuantity has been set by the component
		ProductActions.setQuantity(this.state.selectedQuantity, this.props.tangibleCode, context, /* isInitialization */ true);
		this.setState({ context });
		ProductStore.addChangeListener(this._onChange);

		//I don't necessarily like doing this but CheckoutActions, outside of the commonComponents bundle needs to know when to attach quantity change listener.
		if (!this.state.context && !this.props.tangibleCode) {
			$("body").trigger("mainProductQuantityMounted");
		}
	},

	componentWillUnmount: function () {
		ProductStore.removeChangeListener(this._onChange);

		if (this.props.isDesignMode) {
			parent.window.ComponentActions.childComponentUnloaded(this);
			ProductActions.setQuantity(null, this.props.tangibleCode, this.state.context);
		}
	},

	getInitialState: function () {
		return { selectedQuantity: 1 };
	},

	render: function () {
		var quantity = this.state.selectedQuantity;

		return (
			<span
				data-react-component-name="Quantity"
				data-react-component-category="ProductComponents"
				data-component-id={this.props.dataComponentId}
				data-nested-id={this.props.dataNestedId}
				data-repeated-id={this.props.dataRepeatedId}
				data-theme={+this.props.theme ? this.props.theme : undefined}
				data-custom={this.props.isCustomTheme || null}
				data-child-of={this.props.dataChildOf}
			>
				<input
					type="text"
					value={quantity == null ? 1 : quantity}
					onChange={this.handleAmountChange}
					onBlur={this.handleAmountBlur}
					className={classNames(this.props.className, !this.state.context && !this.props.tangibleCode ? "main-product-quantity" : "")}
					data-override-classes={this.props.className}
					inputMode="numeric"
				/>
			</span>
		);
	}
});

module.exports = Quantity;



// WEBPACK FOOTER //
// ./Javascript/productComponents/Quantity.jsx